// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uTrZC","wrapper":"Menu_wrapper__iRKAN","button":"Menu_button__8XX3g","button--active":"Menu_button--active__PYSzN","text":"Menu_text__zgejj"};